import "../scss/style.scss";
import "./animation.js"
import "./splide_setting.js"
import nodeMarquee from 'node-marquee';

// smooth scroll
$(function () {
  // headerの高さを取得し、headeHeightに代入
  // const headerHeight = document.querySelector('header').offsetHeight;

  //querySelectorAllメソッドを使用してページ内のhref属性が#で始まるものを選択
  //forEachメソッドを使って、各アンカータグにクリックされた時の処理
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {

      // クリックされたときのデフォルトの挙動を防ぐ
      e.preventDefault();

      // クリックされたアンカータグのhref属性を取得
      const href = anchor.getAttribute('href');

      // href属性の#を取り除いた部分と一致するIDを取得
      const target = document.getElementById(href.replace('#', ''));

      //取得した要素の位置を取得するために、getBoundingClientRect()を呼び出し、ページ上の位置を計算。
      //headerの高さを引いて、スクロール位置がヘッダーの下になるように調整します。
      // const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;

      // window.scrollTo()を呼び出して、スクロール位置を設定します。behaviorオプションをsmoothに設定することで、スムーズなスクロールを実現します。
      window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
      });
    });
  });
});

// SP nav
$(document).ready(function () {
  $('.js-nav-onBt').on('click', function () {
    $('.js-nav, .nav-anime').addClass('nav-on');
  });
  $('.js-nav-offBt, .js-nav-link').on('click', function () {
    $('.js-nav.nav-on, .nav-anime.nav-on').removeClass('nav-on');
  });
});

// marquee
$(function () {
  nodeMarquee({
    parent: '#node-marquee01'
  });
  nodeMarquee({
    parent: '#node-marquee02'
  });
  nodeMarquee({
    parent: '#node-marquee03'
  });
  nodeMarquee({
    parent: '#node-marquee04'
  });
});

$(function () {
  var timer = false;
  var prewidth = $(window).width();
  $(window).resize(function () {
    if (timer !== false) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      var nowWidth = $(window).width();
      // if(prewidth !== nowWidth){
      if ((prewidth < 768) && (nowWidth > 768) ||
         (prewidth > 768) && (nowWidth < 768)) {
          location.reload();
      };
      prewidth = nowWidth;
    }, 200);
  });
});
